var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "6d4423be-ac56-40e4-80d9-0aa9abaa4abb",
    gradientUnits: "userSpaceOnUse",
    x1: -3.687,
    x2: 21.428,
    y1: 22.757,
    y2: 2.38
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff33b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#fee72e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#fed51b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#fdca10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#fdc70c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#f3903f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#ed683c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e93e3a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "24e75ea3-5541-49e6-b2ce-74c573bf3744",
    x1: -2.723,
    x2: 22.392,
    xlinkHref: "#6d4423be-ac56-40e4-80d9-0aa9abaa4abb",
    y1: 23.945,
    y2: 3.568
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "44532b40-efc4-45cd-b2b5-b7e09baecd44",
    x1: 0.213,
    x2: 25.328,
    xlinkHref: "#6d4423be-ac56-40e4-80d9-0aa9abaa4abb",
    y1: 27.563,
    y2: 7.187
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.994 5.113a4.294 4.294 0 0 0 -3.656.818 4.251 4.251 0 0 0 -1.61 3.342 1 1 0 0 0 2 0 2.274 2.274 0 1 1 3.472 1.927 4.509 4.509 0 0 0 -2.2 3.8 1 1 0 0 0 2 0 2.524 2.524 0 0 1 1.262-2.1 4.274 4.274 0 0 0 -1.268-7.785z",
    fill: "url(#6d4423be-ac56-40e4-80d9-0aa9abaa4abb)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 1a11 11 0 1 0 11 11 11.013 11.013 0 0 0 -11-11zm0 20a9 9 0 1 1 9-9 9.01 9.01 0 0 1 -9 9z",
    fill: "url(#24e75ea3-5541-49e6-b2ce-74c573bf3744)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    fill: "url(#44532b40-efc4-45cd-b2b5-b7e09baecd44)",
    r: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpDark);
export default __webpack_public_path__ + "static/media/HelpDark.b8ded4d7.svg";
export { ForwardRef as ReactComponent };